import { RootState } from 'store';
import { createSelector } from '@reduxjs/toolkit';
const selectState = (state: RootState) => state.labels;

export const selectLabelsStatuses = createSelector(selectState, ({ isLoading, isInit }) => {
  return { isLoading, isInit };
});
